<template>
  <v-container class="people none-fluid">
    <v-tabs right background-color="transparent" color="rgb(153, 27, 30)">
      <v-tab>CURRENT</v-tab>
      <v-tab @click="$router.push({ name: 'Alumni' })">ALUMNI</v-tab>
    </v-tabs>

    <div v-if="selected === 'person-card'">
      <div v-if="faculty.length">
        <h2>Faculty</h2>

        <v-row>
          <v-col v-for="person in faculty" :key="person.name" cols="6" lg="2">
            <component
              :is="selected"
              :person="person"
              title="Principal Investigator"
            ></component>
          </v-col>
        </v-row>
      </div>

      <div v-if="budget.length">
        <h2>Budget & Business Analyst</h2>

        <v-row>
          <v-col v-for="person in budget" :key="person.name" cols="6" lg="2">
            <component
              :is="selected"
              :person="person"
              title="Budget/Business Analyst"
            ></component>
          </v-col>
        </v-row>
      </div>

      <div v-if="study.length">
        <h2>Study Coordinator</h2>

        <v-row>
          <v-col v-for="person in study" :key="person.name" cols="6" lg="2">
            <component
              :is="selected"
              :person="person"
              title="Study Coordinator"
            ></component>
          </v-col>
        </v-row>
      </div>

      <div v-if="postdoc.length">
        <h2>Postdoctoral Researcher</h2>

        <v-row>
          <v-col v-for="person in postdoc" :key="person.name" cols="6" lg="2">
            <component
              :is="selected"
              :person="person"
              title="Postdoctoral Scholar"
            ></component>
          </v-col>
        </v-row>
      </div>

      <div v-if="phd.length">
        <h2>PhD Students</h2>

        <v-row>
          <v-col v-for="person in phd" :key="person.name" cols="6" lg="2">
            <component
              :is="selected"
              :person="person"
              title="PhD Student"
            ></component>
          </v-col>
        </v-row>
      </div>

      <div v-if="bme.length">
        <h2>BME Rotation PhD Student</h2>

        <v-row>
          <v-col v-for="person in bme" :key="person.name" cols="6" lg="2">
            <component
              :is="selected"
              :person="person"
              title="BME Rotation PhD Student"
            ></component>
          </v-col>
        </v-row>
      </div>

      <div v-if="visitor.length">
        <h2>Student Visitors and Collaborators</h2>

        <v-row>
          <v-col v-for="person in visitor" :key="person.name" cols="6" lg="2">
            <component
              :is="selected"
              :person="person"
              title="Visitors & Remote Collaborators"
            ></component>
          </v-col>
        </v-row>
      </div>

      <div v-if="leave.length">
        <h2>On Leave</h2>

        <v-row>
          <v-col v-for="person in leave" :key="person.name" cols="6" lg="2">
            <component
              :is="selected"
              :person="person"
              title="PhD Student"
            ></component>
          </v-col>
        </v-row>
      </div>

      <div v-if="master.length">
        <h2>Master's Students</h2>

        <v-row>
          <v-col v-for="person in master" :key="person.name" cols="6" lg="2">
            <component
              :is="selected"
              :person="person"
              title="Masters Student"
            ></component>
          </v-col>
        </v-row>
      </div>

      <div v-if="undergrad.length">
        <h2>Undergraduate Students</h2>

        <v-row>
          <v-col v-for="person in undergrad" :key="person.name" cols="6" lg="2">
            <component
              :is="selected"
              :person="person"
              title="Undergraduate Students"
            ></component>
          </v-col>
        </v-row>
      </div>

<!--      <div v-if="viterbi_summer.length">-->
<!--        <h2>SHINE Program</h2>-->

<!--        <v-row>-->
<!--          <v-col-->
<!--            v-for="person in viterbi_summer"-->
<!--            :key="person.name"-->
<!--            cols="6"-->
<!--            lg="2"-->
<!--          >-->
<!--            <component-->
<!--              :is="selected"-->
<!--              :person="person"-->
<!--              title="SHINE Program"-->
<!--            ></component>-->
<!--          </v-col>-->
<!--        </v-row>-->
<!--      </div>-->

<!--      <div v-if="reu.length">-->
<!--        <h2>REU Students</h2>-->

<!--        <v-row>-->
<!--          <v-col v-for="person in reu" :key="person.name" cols="6" lg="2">-->
<!--            <component-->
<!--              :is="selected"-->
<!--              :person="person"-->
<!--              title="REU Student"-->
<!--            ></component>-->
<!--          </v-col>-->
<!--        </v-row>-->
<!--      </div>-->

<!--      <div v-if="sure.length">-->
<!--        <h2>SURE Students</h2>-->

<!--        <v-row>-->
<!--          <v-col v-for="person in sure" :key="person.name" cols="6" lg="2">-->
<!--            <component-->
<!--              :is="selected"-->
<!--              :person="person"-->
<!--              title="SURE Student"-->
<!--            ></component>-->
<!--          </v-col>-->
<!--        </v-row>-->
<!--      </div>-->

      <div v-if="viterbi_curve.length">
        <h2>Viterbi CURVE Students</h2>

        <v-row>
          <v-col
            v-for="person in viterbi_curve"
            :key="person.name"
            cols="6"
            lg="2"
          >
            <component
              :is="selected"
              :person="person"
              title="Viterbi CURVE Student"
            ></component>
          </v-col>
        </v-row>
      </div>

      <div v-if="k12.length">
        <h2>K-12 Students</h2>

        <v-row>
          <v-col
              v-for="person in k12"
              :key="person.name"
              cols="6"
              lg="2"
          >
            <component
                :is="selected"
                :person="person"
                title="K12 Student"
            ></component>
          </v-col>
        </v-row>
      </div>

      <div v-if="reu.length || sure.length || viterbi_summer.length">
        <h2>Summer Student Researchers</h2>
        <h4 v-if="reu.length" >REU Students</h4>
        <v-row>
          <v-col v-for="person in reu" :key="person.name" cols="6" lg="2">
            <component
                :is="selected"
                :person="person"
                title="REU Student"
            ></component>
          </v-col>
        </v-row>
        <h4 v-if="sure.length" >SURE Students</h4>
        <v-row>
          <v-col v-for="person in sure" :key="person.name" cols="6" lg="2">
            <component
                :is="selected"
                :person="person"
                title="SURE Student"
            ></component>
          </v-col>
        </v-row>
        <h4 v-if="viterbi_summer.length">Undergraduate Students</h4>
        <v-row>
          <v-col
              v-for="person in viterbi_summer"
              :key="person.name"
              cols="6"
              lg="2"
          >
            <component
                :is="selected"
                :person="person"
                title="Summer Program"
            ></component>
          </v-col>
        </v-row>
      </div>


      <div v-if="viterbi_fellow.length">
        <h2>Viterbi Fellow Students</h2>

        <v-row>
          <v-col
            v-for="person in viterbi_fellow"
            :key="person.name"
            cols="6"
            lg="2"
          >
            <component
              :is="selected"
              :person="person"
              title="Viterbi Fellow Student"
            ></component>
          </v-col>
        </v-row>
      </div>

      <div v-if="urap.length">
        <h2>URAP Students</h2>

        <v-row>
          <v-col
            v-for="person in urap"
            :key="person.name"
            cols="6"
            lg="2"
          >
            <component
              :is="selected"
              :person="person"
              title="URAP Student"
            ></component>
          </v-col>
        </v-row>
      </div>

      <div v-if="webmaster.length">
        <h2>Webmaster</h2>

        <v-row>
          <v-col v-for="person in webmaster" :key="person.name" cols="6" lg="2">
            <component
              :is="selected"
              :person="person"
              title="Webmaster"
            ></component>
          </v-col>
        </v-row>
      </div>
    </div>
  </v-container>
</template>

<script>
import { getAllPeople } from "../../service/about/people";
import PersonCard from "../utils/PersonCard";
import PersonLink from "../utils/PersonLink";

export default {
  components: {
    PersonCard,
    PersonLink,
  },
  data() {
    return {
      faculty: [],
      budget: [],
      study: [],
      postdoc: [],
      phd: [],
      bme: [],
      visitor: [],
      leave: [],
      master: [],
      undergrad: [],
      viterbi_summer: [],
      viterbi_curve: [],
      viterbi_fellow: [],
      urap: [],
      reu: [],
      sure: [],
      k12: [],
      webmaster: [],
      dialog: false,
      selected: "person-card",
    };
  },
  mounted() {
    getAllPeople()
      .then((result) => {
        const {
          faculty,
          budget,
          study,
          postdoc,
          phd,
          bme,
          visitor,
          leave,
          master,
          undergrad,
          viterbi_summer,
          viterbi_curve,
          viterbi_fellow,
          urap,
          reu,
          sure,
          k12,
          webmaster,
        } = result;

        this.faculty = faculty;
        this.budget = budget;
        this.study = study;
        this.postdoc = postdoc;
        this.phd = phd;
        this.bme = bme;
        this.visitor = visitor;
        this.leave = leave;
        this.master = master;
        this.undergrad = undergrad;
        this.sure = sure;
        this.viterbi_summer = viterbi_summer;
        this.reu = reu;
        this.viterbi_curve = viterbi_curve;
        this.viterbi_fellow = viterbi_fellow;
        this.urap = urap;
        this.k12 = k12;
        this.webmaster = webmaster;
      })
      .catch((err) => {
        console.error(err.message);
      });
  },
};
</script>
